import React from 'react';

function ErrorComponent() {
  return <h1>Something went wrong</h1>;
}

export interface AppProps {
    children: React.ReactNode;
}

export interface AppState {
    hasError: boolean,
    error: Error,
    errorInfo: React.ErrorInfo
}

export class AppErrorBoundary extends React.Component<AppProps, AppState> {
  constructor(props: AppProps) {
    super(props);
    this.state = {
      hasError: false,
      error: { message: '', stack: '', name: '' },
      errorInfo: { componentStack: '' },
    };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    this.setState({ error, errorInfo });
    // eslint-disable-next-line no-console
    console.error('Uncaught Error:', error, errorInfo);
    window.dataLayer.push({
      event: 'Error Boundary',
      error_stack: JSON.stringify(error, Object.getOwnPropertyNames(error)),
    });
  }

  render() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { hasError, error, errorInfo } = this.state;
    const { children } = this.props;

    return hasError ? <ErrorComponent /> : children;
  }
}
